module.exports = __webpack_public_path__ + "img/new_42.d8d85923.jpg";